import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotFoundComponent } from "./modules/layout/not-found/not-found.component";
import { LoggedGuard } from "./providers/guards/logged.guard";
import { LogoutCatalogGuard } from "./providers/guards/logout-catalog.guard";
import { WidthViewComponent } from "./modules/width-view/width-view.component";

export const routes: Routes = [
    {
        path: "catalogo/galicia",
        loadChildren: () =>
            import("./pages/galicia/galicia.module").then(
                (m) => m.GaliciaModule
            ),
    },
    {
        path: "catalogo/octa-auto",
        loadChildren: () =>
            import("./pages/octa-auto/resale-catalog.module").then(
                (m) => m.ResaleCatalogModule
            ),
    },
    {
        path: "",
        pathMatch: "full",
        redirectTo: "/autenticacao",
    },
    {
        path: "login",
        pathMatch: "full",
        redirectTo: "/autenticacao",
    },
    {
        path: "autenticacao",
        loadChildren: () =>
            import("./modules/authentication/authentication.module").then(
                (m) => m.AuthenticationModule
            ),
    },
    {
        path: "onboarding",
        canActivate: [LoggedGuard],
        loadChildren: () =>
            import("./pages/onboarding/onboarding.module").then(
                (m) => m.OnboardingModule
            ),
    },
    {
        path: "app",
        canActivate: [LoggedGuard],
        loadChildren: () =>
            import("./pages/pages.module").then((m) => m.PagesModule),
    },
    {
        path: "catalogo",
        loadChildren: () =>
            import("./pages/catalog/catalog.module").then(
                (m) => m.CatalogModule
            ),
    },
    {
        path: "catalogo-aberto",
        loadChildren: () =>
            import("./pages/open-catalog/open-catalog.module").then(
                (m) => m.OpenCatalogModule
            ),
    },
    {
        path: "catalogo-whatsapp",
        loadChildren: () =>
            import("./pages-logout/pages-logout.module").then(
                (m) => m.LogoutCatalogModule
            ),
    },
    {
        path: "404",
        component: NotFoundComponent,
    },
    {
        path: "configuration/width",
        pathMatch: "full",
        component: WidthViewComponent,
    },
    {
        path: "**",
        redirectTo: "/404",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
